/* eslint-disable import/prefer-default-export */
import { PrivilegesView } from '@src/modules/privileges/configurations'
import type { PrivilegeSummaryItem } from './models'

// Reducer
export const defaultState = {
  privilegesList: [] as PrivilegeSummaryItem[],
  isPending: false,
  errors: null as any,
  selectedView: PrivilegesView.Used
}

export type PrivilegesState = typeof defaultState
